module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "plm_hd",
    attrs: {
      "id": "ctn1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PROV_genpref"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PROV_autpref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PROV_bibliog"
    }
  }, [_vm._v("Select bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PROV_wisdom"
    }
  }, [_vm._v("The wisdom of God")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PROV_wisdom#sigil_toc_id_1"
    }
  }, [_vm._v("1. Where are the proverbs from?")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PROV_wisdom#sigil_toc_id_2"
    }
  }, [_vm._v("2. Who are the proverbs for?")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PROV_wisdom#sigil_toc_id_3"
    }
  }, [_vm._v("3. What are the proverbs for?")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Wisdom’s portrait (1:1 – 9:18)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The town crier (1:20–33)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Wisdom needs to be searched for (2:1–9)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A winsome personality (2:10–15)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Wisdom celebrates life (3:13–18)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Wisdom likes to explore (4:1–9)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Wisdom stands for justice")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Wisdom likes things ordered")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Wisdom illustrates the pattern of creation (3:19–20)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The full-colour portrait (8:1–36)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch01#sigil_toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Wisdom: her main features")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Wisdom’s instructors and Wisdom’s detractors (1:1 – 9:18)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Ten fatherly talks")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Talks about evil company (1:8–19)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Talks about avoiding wicked men and the lure of the adulterous woman (2:1–22)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Talks about duty to God (3:1–12)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Talks about duty to the neighbour (3:21–35)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Talks about Wisdom herself (4:1–9)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. More talks about evil company (4:10–19)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Talks about vigilance (4:20–27)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. General talks, warning against folly (6:1–19)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Wisdom’s detractors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Problem pupils")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch02#sigil_toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The way of Wisdom or the way of Folly? (9:1–6, 13–18)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Wisdom’s methods")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch03#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The theology of lived experience")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch03#sigil_toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. ‘An anthology of gnomes’")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch03#sigil_toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Fourfold structure")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch03#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Wisdom’s imagination")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch03#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: a brief note on practical theology, philosophy and education")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch04#sigil_toc_id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Wisdom’s values: foundations (10:1 – 22:16)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch04#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The wise sayings of Solomon")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch04#sigil_toc_id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The fear of the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch04#sigil_toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Love")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch04#sigil_toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Justice")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch04#sigil_toc_id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Character: a summary")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Wisdom’s values: the practical dimension (10:1 – 22:16)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Family, marriage and parenthood")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Diligence, creativity and hard work")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Health")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Security and safety")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Material sufficiency")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The importance of appropriate speech")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The king’s glory and the national honour")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Animal welfare")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Life, freedom and hope")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch05#sigil_toc_id_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Knowledge and understanding")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch06#sigil_toc_id_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Wisdom’s values: the words of the wise (22:17 – 31:31)")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch06#sigil_toc_id_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Sayings of the wise (22:17 – 24:22; 24:23–34)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch06#sigil_toc_id_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Proverbs of Solomon: Hezekiah’s edition (25:1 – 29:27)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch06#sigil_toc_id_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Sayings of Agur (30:1–33)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch06#sigil_toc_id_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Thoughts from the queen mother (31:1–9)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_ch06#sigil_toc_id_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Epilogue: the wife of noble character: Wisdom at home (31:10–31)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_conc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: godliness in working clothes1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_NIVad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NIV Bible Speaks Today")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_OTseries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bible Speaks Today: Old Testament series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PROV_NTseries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bible Speaks Today: New Testament series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/IVPtbs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Academic Textbook Selector")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad422140","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/PROV_contents.vue
// module id = 66
// module chunks = 0